export default {
  functionKey: "SUBSTITUE",
  title: "SUBSTITUE",
  group: "Organisation",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 2,
  requiredArguments: [
    { argumentKey: "Search", name: "Recherche", empty: true },
    { argumentKey: "Replace", name: "Remplacement", empty: true }
  ],
  expectedArguments: [
    { name: "Recherche", argumentKey: "Search", single: true, initialValue: "" },
    { name: "Remplacement", argumentKey: "Replace", single: true, initialValue: "" }
  ],
  description: "Remplace le premier argument par le second dans la colonne d'origine",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${origin}.replaceAll(${args[0]}, ${args[1]});`;
    return { displayCode: code, safeCode: code };
  }
}
